import { EMPTY_LANG_COMMENT, EMPTY_USERINFO_OBJECT } from '@/helpers/constants';

const defaultSummary = (id: string) => ({
  id,
  version: 1,
  title: EMPTY_LANG_COMMENT,
  attachment: '',
  executiveProblemDescription: EMPTY_LANG_COMMENT,
  rootCause: EMPTY_LANG_COMMENT,
  inspectionType: '',
  inspectionTypeComment: EMPTY_LANG_COMMENT,
  immediateMeasureComment: EMPTY_LANG_COMMENT,
  consequences: EMPTY_LANG_COMMENT,
  executiveSummaryAffectedVehicleResponses: [],
  classificationSelected: '',
  classificationComment: EMPTY_LANG_COMMENT,
  possibleCauserSelected: 'Internal',
  possibleCauserCostCenter: '',
  possibleCauserPossibleCauser: '',
  possibleCauserSupplierAndSupplierID: '',
  possibleCauserSupplierNumber: '',
  possibleCauserSupplierName: '',
  possibleCauserTier1SupplierNumber: '',
  possibleCauserTier1SupplierName: '',
  possibleCauserTier1SupplierAcknowledged: false,
  possibleCauserConfirmPlantToPlant: false,
  riskComment: EMPTY_LANG_COMMENT,
  riskPotentiallyRelevant: false,
  triggerBuildUpApproval: EMPTY_LANG_COMMENT,
  possibleCauserContactPersonForSupplierManagement: '',
  triggerSource: '',
  triggerFailureOn: '',
  referenceSystem: '',
  affectedVehiclesByPlants: {},
  amgVehicles: '',
  attachmentId: '',
  attachmentName: '',
  attachmentType: '',
  blockingRecommendation: '',
  btv: EMPTY_USERINFO_OBJECT,
  edited: false,
  estimatedNOKRate: null,
  iraNumber: '',
  numberOfAffectedPlantsAndModels: '',
  referencedSystem: '',
  referencedSystemName: '',
  status: '',
  statusComment: '',
  statusDate: '',
  statusUserCode: '',
  statusUserRole: '',
  successfulStatuses: [],
  typeOfAffectedPlantsSelection: '',
  vehicleVolumeNumbers: '',
});

export default defaultSummary;
